import { render, staticRenderFns } from "./ConsumptionVoucherPool.vue?vue&type=template&id=96ff3d1e&scoped=true"
import script from "./ConsumptionVoucherPool.vue?vue&type=script&lang=js"
export * from "./ConsumptionVoucherPool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ff3d1e",
  null
  
)

export default component.exports